import { render, staticRenderFns } from "./assistant-failure.vue?vue&type=template&id=881a6b3c&scoped=true"
import script from "./assistant-failure.vue?vue&type=script&lang=js"
export * from "./assistant-failure.vue?vue&type=script&lang=js"
import style0 from "./assistant-failure.vue?vue&type=style&index=0&id=881a6b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881a6b3c",
  null
  
)

export default component.exports